import React, { useEffect, useState } from "react";
import AdminLayout from "../../../components/AdminLayout";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";

const Industry = () => {
  const [industry, setIndustry] = useState([]);
  const [usedIndustryIds, setUsedIndustryIds] = useState(new Set());

  const navigate = useNavigate();

  useEffect(() => {
    const fetchIndustriesAndPortfolios = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const [industryRes, portfolioRes] = await Promise.all([
          axios.get(`${apiUrl}/api/industry`),
          axios.get(`${apiUrl}/api/company-portfolio`),
        ]);

        const sortedIndustries = industryRes.data.industries.sort((a, b) =>
          a.industry.localeCompare(b.industry)
        );

        const portfolios = portfolioRes.data.company || [];

        const usedIds = new Set(
          portfolios
            .map((p) => {
              const ind = p.industry;
              return typeof ind === "object" && ind?._id
                ? ind._id
                : typeof ind === "string"
                ? ind
                : null;
            })
            .filter(Boolean)
        );

        setIndustry(sortedIndustries);
        setUsedIndustryIds(usedIds);
      } catch (error) {
        console.error("Error fetching industries and portfolios:", error);
      }
    };

    fetchIndustriesAndPortfolios();
  }, []);

  const handleDelete = async (id, name) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete "${name}"?`
    );
    if (!confirmDelete) return;

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const access_token = localStorage.getItem("access_token");

      await axios.delete(`${apiUrl}/api/industry/${id}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });

      setIndustry((prev) => prev.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting industry:", error);
    }
  };

  return (
    <AdminLayout>
      <div className="pages-headers">
        <h2>
          Company Industry
          <NavLink to="/admin/add/industry" className="theme-cta">
            <i className="las la-plus-circle"></i> Add Company Industry
          </NavLink>
        </h2>
      </div>

      <div className="row mobilerows">
        <div className="col-md-12">
          <div className="infos-table">
            <div className="table-responsive">
              <table className="table nowrap">
                <thead>
                  <tr>
                    <th>Company Industry</th>
                    <th className="text-center">Edit</th>
                    <th className="text-center">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {industry.map((item) => (
                    <tr key={item._id}>
                      <td>{item.industry}</td>
                      <td className="text-center">
                        <Link
                          to={`/admin/edit/industry/${item._id}`}
                          title="Edit"
                        >
                          <i className="las la-pencil-alt"></i>
                        </Link>
                      </td>
                      <td className="text-center">
                        {!usedIndustryIds.has(item._id) ? (
                          <button
                            className="delete-btn"
                            onClick={() =>
                              handleDelete(item._id, item.industry)
                            }
                            title="Delete"
                          >
                            <i className="las la-trash"></i>
                          </button>
                        ) : (
                          <span title="Industry is in use">
                            <i className="las la-lock text-muted"></i>
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Industry;
